
<div class="top-section">
    <h6 class="heading mb-0">{{ ss.t('comingSoon_title') }}</h6>
    <app-svg name="close" role="button" (click)="closeDialog()" [color]="ss.theme().color8"></app-svg>
</div>

<p class="text-16-400 color-7 mb-0 ri-pt-1 ri-ps-4">{{ ss.t('comingSoon_content') }}</p>

<div class="body-section">
    <div class="list-items-block">
        <!-- Android -->
        <div class="platform-item">
            <div class="platform-info">
                <app-svg name="android" class="icon-sm" [color]="ss.theme().color8"></app-svg>
                <span class="text-14-500 list-aviable-text color-8">{{ ss.t('common_android') }}</span>
            </div>
            <button class="insight-btn-ink text-14-500 list-aviable-text" (click)="openPlayStore()">
                {{ ss.t('common_playstore') }}
                <app-svg name="connectLink" class="icon-xs" [color]="ss.theme().color12"></app-svg>
            </button>
        </div>

        <!-- iOS -->
        <div class="platform-item">
            <div class="platform-info">
                <app-svg name="ios" class="icon-sm" [color]="ss.theme().color8"></app-svg>
                <span class="text-14-500 list-aviable-text color-8">{{ ss.t('common_iOS') }}</span>
            </div>
            <button class="insight-btn-ink text-14-500 list-aviable-text" (click)="openAppStore()">
                {{ ss.t('common_appstore') }}
                <app-svg name="connectLink" class="icon-xs" [color]="ss.theme().color12"></app-svg>
            </button>
        </div>

        <!-- Windows -->
        <div class="platform-item">
            <div class="platform-info">
                <app-svg name="windows" class="icon-sm" [color]="ss.theme().color8"></app-svg>
                <span class="text-14-500 list-aviable-text color-8">{{ ss.t('common_windows') }}</span>
            </div>
            <div class="insight-soon-btn-ink text-14-500 list-aviable-text">
                {{ ss.t('common_comingSoon') }}
            </div>
        </div>

        <!-- macOS -->
        <div class="platform-item">
            <div class="platform-info">
                <app-svg name="apple" class="icon-sm" [color]="ss.theme().color8"></app-svg>
                <span class="text-14-500 list-aviable-text color-8">{{ ss.t('common_macOS') }}</span>
            </div>
            <div class="insight-soon-btn-ink text-14-500 list-aviable-text">
                {{ ss.t('common_comingSoon') }}
            </div>
        </div>
    </div>
</div>
